import React, { useState, useEffect, useRef } from 'react';
import { Search, User, ShoppingBag, Phone, LogOut, LogIn } from 'lucide-react';
import { Input } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import SlideCart from '../../../components/SlideCart';
import CartView from './CartView';
import { Box, Button } from '@mui/material';

const Header = ({ setSidebarOpen, tempCart, logo, setSearchTerm, categories,
    activeCategory, handleCategoryClick, showProfile, setShowProfile, setShowCheckout, showCheckout,
    showOrders, setShowOrders, setShowLoginPopup, setProduct_Details, isCartOpen, setIsCartOpen, handleTerms, handleRefundPolicy,
    categorizedProducts }) => {
    const [localSearchTerm, setLocalSearchTerm] = useState('');
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [showProfileDropdown, setShowProfileDropdown] = useState(false);
    const profileDropdownRef = useRef(null);
    const user = JSON.parse(localStorage.getItem("user"));
    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                profileDropdownRef.current &&
                !profileDropdownRef.current.contains(event.target)
            ) {
                setShowProfileDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    categories = categories.filter(category =>
        category?.Name !== '' &&
        categorizedProducts[category._id]?.length > 0
    );

    const handleProfileClick = () => {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user) {
            setShowLoginPopup(true);
            setShowProfileDropdown(false);
        } else {
            setShowProfile(true);
            setShowOrders(false);
            setShowCheckout(false);
            setProduct_Details(null);
            setShowProfileDropdown(false);
        }
    };

    const handleOrderClick = () => {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user) {
            setShowLoginPopup(true);
            setShowProfileDropdown(false);
        } else {
            // Ensure Orders view re-renders every time from header
            if (showOrders) {
                setShowOrders(false);
                setTimeout(() => setShowOrders(true), 0);
            } else {
                setShowOrders(true);
            }
            setShowProfile(false);
            setShowCheckout(false);
            setProduct_Details(null);
            setShowProfileDropdown(false);
        }
    };

    const navigate = useNavigate();
    const handleLogout = async () => {
        await localStorage.clear();
        navigate("/customer_login");
        setShowProfileDropdown(false);
    };

    const handleCartClick = () => {
        //iph todo: 47
        //console.log('handleCartClick')
        setShowProfileDropdown(false);
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user) {
            setShowLoginPopup(true);
        } else {
            //iph todo: 47
            //console.log('setIsCartOpen', isCartOpen)
            setIsCartOpen(true);
        }
    };
    useEffect(() => {
        if (isCartOpen) {
            //iph todo: 47
            //console.log("SlideCart is being rendered");
        }
        setShowProfileDropdown(false);
    }, [isCartOpen]);

    // Categories Navigation
    const CategoriesNav = ({ categories, activeCategory, handleCategoryClick }) => (
        <Box sx={{
            backgroundColor: 'white',
            borderBottom: '1px solid #e0e0e0',
            position: 'sticky',
            top: { xs: '85px', sm: '90px', md: '95px' },
            zIndex: 40
        }}>
            <Box sx={{
                maxWidth: '1300px',
                margin: '0 auto',
                padding: { xs: '8px 15px', sm: '30px 20px 10px 20px' }
            }}>
                <Box sx={{
                    display: 'flex',
                    gap: { xs: '8px', sm: '10px' },
                    alignItems: 'center',
                    overflowX: 'auto',
                    '&::-webkit-scrollbar': {
                        height: '4px'
                    },
                    '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1'
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: '#888',
                        borderRadius: '4px'
                    }
                }}>
                    <Button
                        onClick={() => {
                            setShowProfile(false);
                            setShowOrders(false);
                            setShowCheckout(false);
                            setProduct_Details(null);
                            handleCategoryClick(null)
                        }}
                        sx={{
                            backgroundColor: !activeCategory ? '#5190A6' : 'transparent',
                            color: !activeCategory ? 'white' : '#333',
                            padding: '8px 16px',
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            '&:hover': {
                                backgroundColor: !activeCategory ? '#457A8F' : '#f5f5f5'
                            }
                        }}
                    >
                        <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>☰</Box>
                        All Categories
                        <span>→</span>
                    </Button>

                    {categories?.map((category) => (
                        <Button
                            key={category._id}
                            onClick={() => {
                                setShowProfile(false);
                                setShowOrders(false);
                                setShowCheckout(false);
                                setProduct_Details(null);
                                handleCategoryClick(category)
                            }}
                            sx={{
                                color: category._id === activeCategory ? 'white' : '#333',
                                backgroundColor: category._id === activeCategory ? '#5190A6' : 'transparent',
                                '&:hover': {
                                    backgroundColor: category._id === activeCategory ? '#457A8F' : '#f5f5f5'
                                },
                                padding: '8px 16px',
                                borderRadius: '8px',
                                textTransform: 'none',
                                fontWeight: category._id === activeCategory ? 600 : 400,
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {category.Name}
                        </Button>
                    ))}
                </Box>
            </Box>
        </Box>
    );

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        setShowProfileDropdown(false);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleSearch = () => {
        setShowProfile(false);
        setShowProfileDropdown(false);
        setProduct_Details(null);
        setShowCheckout(false);
        setShowOrders(false);
        setSearchTerm(localSearchTerm);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
        setShowProfileDropdown(false);
    };

    return (
        <>
            {/* Styles */}
            <style>
                {`
                   /* General Styles */
                   body {
                       margin: 0;
                       font-family: Arial, sans-serif;
                   }
                   
                   /* Top Banner */
                   .top-banner {
                       background-color: #2D3748;
                       color: white;
                       padding: 0.3rem;
                       text-align: center;
                       font-size: 0.875rem;
                       width: 100%;
                       position: fixed;
                       top: 0;
                       z-index: 51;
                   }
                   
                   /* Header Container */
                   .header-container {
                       background: white;
                       box-shadow: 0 1px 3px rgba(0,0,0,0.05);
                       position: fixed;
                       top: 1rem;
                       left: 0;
                       right: 0;
                       z-index: 50; /* Set z-index lower than cart */
                   }
                   
                   /* Header Content */
                   .header-content {
                       display: flex;
                       align-items: center;
                       gap: 2rem;
                       padding: 0.75rem 2rem;
                       max-width: 1920px;
                       margin: 0 auto;
                   }
                   
                   /* Support Container */
                   .support-container {
                       display: flex;
                       align-items: center;
                       gap: 0.5rem;
                       color: #64748B;
                   }
                   
                   .phone-icon {
                       color: #3488A4;
                   }
                   
                   /* Search Container */
                   .search-container {
                       flex: 1;
                       max-width: 1500px;
                       display: flex;
                       align-items: center;
                   }
                   
                   .search-input-container {
                       flex: 1;
                       position: relative;
                       background: #F8F9FA;
                       border-radius: 0.5rem;
                       padding: 0.75rem 1rem;
                   }
                   
                   .search-input {
                       width: 100%;
                       background: transparent;
                       border: none;
                       outline: none;
                       color: #4B5563;
                       font-size: 0.875rem;
                   }
                   
                   .search-button {
                       display: flex;
                       align-items: center;
                       justify-content: center;
                       background-color: #3488A4;
                       color: white;
                       padding: 0.75rem;
                       border-radius: 0 0.5rem 0.5rem 0;
                       height: 48px;
                       cursor: pointer;
                       border: none;
                       transition: background-color 0.2s ease;
                   }
                   
                   .search-button:hover {
                       background-color: #2d7a98;
                   }
                   
                   /* User Button */
                   .user-button {
                       display: flex;
                       align-items: center;
                       justify-content: center;
                       background: transparent;
                       padding: 0.5rem;
                       border: none;
                   }
                   
                   /* Cart Button */
                   .cart-button {
                       display: flex;
                       align-items: center;
                       gap: 0.5rem;
                       border-radius: 5px;
                       background-color: #3488A4;
                       color: white;
                       padding: 0.75rem 1.25rem;
                       border: 0;
                       font-size: 0.9375rem;
                       min-height: 48px;
                   }
                   
                   /* Actions Container */
                   .actions-container {
                       display: flex;
                       align-items: center;
                       gap: 1rem;
                   }
                   
                   /* Cart Count Badge */
                   .cart-count,
                   .mobile-cart-count {
                       position: absolute;
                       top: -8px;
                       right: 8px;
                       background-color: #ff4444;
                       color: white;
                       border-radius: 50%;
                       width: 20px;
                       height: 20px;
                       display: flex;
                       align-items: center;
                       justify-content: center;
                       font-size: 12px;
                       font-weight: 600;
                       border: 2px solid white;
                   }
                   
                   /* Profile Dropdown */
                   .profile-dropdown {
                       position: absolute;
                       top: calc(100% + 10px);
                       right: 0;
                       background: white;
                       border-radius: 8px;
                       box-shadow: 0 4px 12px rgba(0,0,0,0.1);
                       min-width: 200px;
                       padding: 8px;
                       z-index: 1000;
                   }
                   
                   .profile-dropdown::before {
                       content: '';
                       position: absolute;
                       top: -8px;
                       right: 20px;
                       width: 16px;
                       height: 16px;
                       background: white;
                       transform: rotate(45deg);
                       box-shadow: -2px -2px 5px rgba(0,0,0,0.04);
                   }
                   
                   /* Dropdown Item */
                   .dropdown-item {
                       padding: 12px 16px;
                       display: flex;
                       align-items: center;
                       color: #333;
                       text-decoration: none;
                       cursor: pointer;
                       transition: background-color 0.2s;
                       border-radius: 6px;
                   }
                   
                   .dropdown-item:hover {
                       background-color: #f8f9fa;
                   }
                   
                   .logout-item {
                       color: #dc3545;
                       border-top: 1px solid #eee;
                       margin-top: 8px;
                       padding-top: 12px;
                   }
                   
                   .logout-item:hover {
                       background-color: #fff1f1;
                   }
                   
                   /* Mobile Styles */
                   @media (max-width: 768px) {
                       .header-content {
                           flex-direction: column;
                           gap: 1rem;
                           padding: 0.75rem 1rem;
                       }
                   
                       .mobile-top {
                           display: flex;
                           justify-content: space-between;
                           align-items: center;
                           width: 100%;
                           margin-bottom: 0.75rem;
                       }
                   
                       .mobile-logo {
                           height: 40px;
                           width: auto;
                       }
                   
                       .mobile-cart-button {
                           display: flex;
                           align-items: center;
                           justify-content: center;
                           background-color: #3488A4;
                           color: white;
                           width: 48px;
                           height: 48px;
                           border-radius: 0.5rem;
                           position: relative;
                       }
                   
                       .search-container {
                           width: 100%;
                           max-width: 100%;
                           order: 1;
                       }
                   
                       .slide-cart {
                           position: fixed;
                           top: 0;
                           right: 0;
                           bottom: 0;
                           width: 100%;
                           max-width: 100%;
                           z-index: 2000; /* Ensure it has a high z-index to show above other elements */
                           background-color: white;
                           overflow-y: auto;
                           transform: translateX(0);
                           transition: transform 0.3s ease-in-out;
                       }
                   }
                   
                   /* Desktop Styles */
                   @media (min-width: 769px) {
                       .mobile-only {
                           display: none;
                       }
                   }
                   
                   /* Slide Cart Backdrop */
                   .backdrop {
                       position: fixed;
                       top: 0;
                       left: 0;
                       right: 0;
                       bottom: 0;
                       background-color: rgba(0, 0, 0, 0.5);
                       z-index: 1500; /* Ensure backdrop is below the cart */
                   }
                   
                `}
            </style>

            <header className="header-container">
                <div className="top-banner">
                    {/* Sign In and receive 10% discount on your first order */}
                </div>

                <div className="header-content">
                    {isMobile ? (
                        <div className="mobile-top">
                            <img
                                src={logo}
                                alt="PHRx Logo"
                                className="mobile-logo"
                                onClick={() => setSidebarOpen(true)}
                            />
                            <Button
                                className="mobile-cart-button"
                                onClick={handleCartClick}
                            >
                                <ShoppingBag strokeWidth={2} size={24} />
                                {tempCart?.length > 0 && (
                                    <span className="mobile-cart-count">
                                        {tempCart?.reduce((sum, item) => sum + item.quantity, 0)}
                                    </span>
                                )}
                            </Button>
                        </div>
                    ) : (
                        <>
                            <img
                                src={logo}
                                alt="PHRx Logo"
                                style={{ width: '8%', height: 'auto', cursor: 'pointer' }}
                                onClick={() => setSidebarOpen(true)}
                            />
                            <div className="support-container">
                                {/* <Phone size={18} className="phone-icon" />
                                <span style={{ fontSize: '0.875rem' }}>
                                    Support 24/7:<br />
                                    <a href="tel:+1800001658" className="phone-number">+1800-001-658</a>
                                </span> */}
                            </div>
                        </>
                    )}

                    {/* Search and Actions */}
                    <div className="search-container">
                        <div className="search-input-container">
                            <Input
                                type="text"
                                placeholder="What are you looking for?"
                                className="search-input"
                                value={localSearchTerm}
                                onChange={(e) => setLocalSearchTerm(e.target.value)}
                                onKeyPress={handleKeyPress}
                            />
                        </div>
                        <Button className="search-button" onClick={handleSearch}>
                            <Search strokeWidth={2.5} size={24} />
                        </Button>
                    </div>
                    <div className="actions-container">
                        {!isMobile && (
                            <>
                                <div style={{ position: 'relative' }}>
                                    <Button
                                        className="user-button"
                                        onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                                    >
                                        <User strokeWidth={1.8} size={28} color="#374151" />
                                    </Button>

                                    {showProfileDropdown && (
                                        <div
                                            className="profile-dropdown"
                                            ref={profileDropdownRef}
                                        >
                                            {!user ?
                                                <div className="dropdown-item logout-item" onClick={handleLogout}>
                                                    <LogIn size={18} style={{ marginRight: '8px' }} />
                                                    Login
                                                </div>
                                                :
                                                <>
                                                    <div className="dropdown-item" onClick={handleProfileClick}>
                                                        Profile
                                                    </div>
                                                    <div className="dropdown-item" onClick={handleOrderClick}>
                                                        My Orders
                                                    </div>
                                                    <div className="dropdown-item" onClick={handleRefundPolicy}>
                                                        Refund Policy
                                                    </div>
                                                    <div className="dropdown-item" onClick={handleTerms}>
                                                        Terms & Conditions
                                                    </div>
                                                    <div className="dropdown-item logout-item" onClick={handleLogout}>
                                                        <LogOut size={18} style={{ marginRight: '8px' }} />
                                                        Logout
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    )}
                                </div>
                                <Button
                                    onClick={handleCartClick}
                                    className="cart-button"
                                >
                                    Cart
                                    <ShoppingBag strokeWidth={2} size={20} className="shopping-bag" />
                                    {tempCart?.length > 0 && (
                                        <span className="cart-count">
                                            {tempCart?.reduce((sum, item) => sum + item.quantity, 0)}
                                        </span>
                                    )}
                                </Button>
                            </>
                        )}
                        <SlideCart isOpen={isCartOpen} onClose={() => setIsCartOpen(false)}>
                            <CartView
                                setShowOrders={setShowOrders}
                                setShowProfile={setShowProfile}
                                setProduct_Details={setProduct_Details}
                                handleCategoryClick={handleCategoryClick}
                                showCheckout={showCheckout}
                                setShowCheckout={setShowCheckout}
                                onClose={() => setIsCartOpen(false)}
                            />
                        </SlideCart>
                    </div>
                </div>
            </header>
            <CategoriesNav
                categories={categories}
                activeCategory={activeCategory}
                handleCategoryClick={handleCategoryClick}
            />
        </>
    );
};

export default Header;